const ScreenSizeEnum = Object.freeze({
  MORE_LG: 1,
  BETWEEN_MD_LG: 2,
  BETWEEN_MD_CUSTOM_MD: 3,
  BETWEEN_SM_MD_CUSTOM: 4,
  BETWEEN_XS_SM: 5
});

export default (ScreenSizeEnum);
